/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnfollowTagMutationVariables = Types.Exact<{
  tag_id: Types.Scalars['String'];
}>;


export type UnfollowTagMutation = { __typename: 'Mutation', unfollowTag: { __typename: 'TagFollow', id: string | null } | null };


export const UnfollowTagDocument = gql`
    mutation unfollowTag($tag_id: String!) {
  unfollowTag(tag_id: $tag_id) {
    id
  }
}
    `;
export type UnfollowTagMutationFn = Apollo.MutationFunction<UnfollowTagMutation, UnfollowTagMutationVariables>;

/**
 * __useUnfollowTagMutation__
 *
 * To run a mutation, you first call `useUnfollowTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowTagMutation, { data, loading, error }] = useUnfollowTagMutation({
 *   variables: {
 *      tag_id: // value for 'tag_id'
 *   },
 * });
 */
export function useUnfollowTagMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowTagMutation, UnfollowTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowTagMutation, UnfollowTagMutationVariables>(UnfollowTagDocument, options);
      }
export type UnfollowTagMutationHookResult = ReturnType<typeof useUnfollowTagMutation>;
export type UnfollowTagMutationOptions = Apollo.BaseMutationOptions<UnfollowTagMutation, UnfollowTagMutationVariables>;